import { GET_THIRD_PARTY_LICENSE_HAYNES, GET_THIRD_PARTY_LICENSE_HAYNES_FAILED, GET_THIRD_PARTY_LICENSE_HAYNES_SUCCESS } from './types'
import * as requests from '@cbgms/api/modules/third-party-license/haynes/requests'
import * as models from '@cbgms/api/modules/third-party-license/haynes/models'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const getThirdPartyLicensesHaynes = () =>
  AsyncAction<models.GetThirdPartyLicensesHaynesResponse>({
    type: [GET_THIRD_PARTY_LICENSE_HAYNES, GET_THIRD_PARTY_LICENSE_HAYNES_SUCCESS, GET_THIRD_PARTY_LICENSE_HAYNES_FAILED],
    payload: {
      api: 'gms',
      request: requests.getThirdPartyLicensesHaynesRequest()
    }
  })
